import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { LayoutService } from '../../services/layout.service';
import { SharedHttpService } from '../../services/shared-http.service';
declare const scannerObj: any;

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss']
})
export class ScannerComponent implements OnInit {
  constructor(public caseService: CaseService, private layout: LayoutService, public sharedService: SharedHttpService, private router: Router,) {
    this.layout.scannerstatus = true;
  }

  @Output() HideMe: EventEmitter<any> = new EventEmitter<any>();
  @Output() SaveScan: EventEmitter<any> = new EventEmitter<any>();

  @Input() loadscanner: Observable<void>;
  @Input() attachTypesArr: any;
  @Input() eObjectionRequestId: any;
    @Input() isinternal: any;
  // @Input() selectedFile: any;

  attachTypeId: any=100;
  
  DWObject: any;
  containerId = "dwtcontrolContainer";
  caseObject: any;
  otherTypeInfo: any="";
  // incommingOrgName: string;
  // description: any;
  fileName: any = "اسم المرفق";

  ngOnInit(): void {
    this.caseObject = this.caseService.case;
    this.loadscanner.subscribe(a => {
      setTimeout(() => {
        if (document.getElementById("webtwains") != null)
          document.getElementById("webtwains").remove();
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.id = "webtwains";
        s.src = `${window.location.origin}/assets/Resources/dynamsoft.webtwain.initiate.js`;
        document.head.appendChild(s);
        if (document.getElementById("webtwains2") != null)
          document.getElementById("webtwains2").remove();
        var s2 = document.createElement("script");
        s2.type = "text/javascript";
        s2.id = "webtwains2";
        s2.src = `${window.location.origin}/assets/Resources/dynamsoft.webtwain.config.js`;
        document.head.appendChild(s2);
        if (document.getElementById("webtwains3") != null)
          document.getElementById("webtwains3").remove();
        var s3 = document.createElement("script");
        s3.type = "text/javascript";
        s3.id = "webtwains3";
        s3.src = `${window.location.origin}/assets/js/webTwain.js`;
        document.head.appendChild(s3);
      }, 100);

    });
  }

  Back() {
    this.HideMe.emit(true);
  }


  saveFileAsPdf() {
    this.DWObject = scannerObj();
    this.caseObject = this.caseService.getCaseData();
    let nameOfFile = (<HTMLInputElement>document.getElementById('fileName')).value;

    let DWObject = scannerObj();
    let imagesCount = DWObject.HowManyImagesInBuffer;
    let arr = [];
    for (let d = 0; d < imagesCount; d++)
      arr.push(d);
    DWObject.ConvertToBlob(arr, 4, (result, _indices, type) => {
      var fileName = nameOfFile + ".pdf";
      var formData = new FormData();

      formData.append('reportProgress', 'true');
        formData.append('observe', 'events');
        formData.append('file', result, fileName);
        // formData.append('file', this.selectedFile.target.files[0]);
        formData.append('eObjectionRequestId', this.eObjectionRequestId);
        // formData.append('fileType', this.selectedFile.target.files[0].type);
        formData.append('isinternal', this.isinternal);
        formData.append('attachmentTypeId', this.attachTypeId);
        formData.append('otherName', this.otherTypeInfo);
  
  
      this.sharedService.post(`api/ObjectionRequest/UploadAttachment`, formData).subscribe(results => {
        this.sharedService.showSuccessKey("AttachmentUploadedSuccessfully");

        this.Back();
      });
    }, (errorCode, errorString) => {
    }
    );
  }

  gosuccess(DWObject) {
    DWObject.RemoveAllImages();
    this.HideMe.emit(true);
    this.SaveScan.emit(true);
    this.sharedService.showSuccessKey('SavedSuccessfully')
  }

  previous() {
    this.DWObject = scannerObj();
    this.DWObject.CurrentImageIndexInBuffer -= 1;
  }
  next() {
    this.DWObject = scannerObj();
    this.DWObject.CurrentImageIndexInBuffer += 1;
  }
}
